import React from 'react';
import Icon, { IconProps } from '../Icon';

const IconArrowDownBold: React.FC<IconProps> = ({ ...props }) => {
  const fill = props.fill;
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 9L12 15L18 9H6Z"
        fill={fill}
      />
    </Icon>
  );
};

export default IconArrowDownBold;
